// extracted by mini-css-extract-plugin
export default {"container":"profileNotifications_container__21kF-"};